import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Red_Btn.css'
import { faAngleRight, faArrowRight, faPlay } from '@fortawesome/free-solid-svg-icons'

const Red_Btn = (props) => {
    return (
        <button className="Red_Btn" onClick={props?.onClick} type='button'>

            <p className='btn_text'>{props?.btn_name}</p>

            <div className='icon_holder'>
                {/* <FontAwesomeIcon icon={faArrowRight} className='icon' /> */}
            </div>

        </button>
    )
}

export default Red_Btn
